import workspace from "./workspace";
import sqftShape from "./shapes/sqftShape";
//todo sqft-react
// import {setDataToQt} from "../postMessage";

export default new function() {

  var _self = this;

  this.store = {
    shapes: [],
    cfg: {},
    exportData: null
  };

  this.init = function() {
    // $('#saveHistory').click(_self.rememberShapes);
    // $('#restoreHistory').click(_self.restoreShapesFromHistory);
    // $('#consoleShapesFromHistory').click(_self.consoleShapesFromHistory);
    window.clearHistory = function() {
      this.store.shapes = [];
      this.store.exportData = null;
    }
  };
  // this.addEvent = function(eventName, eventData) {
  //   switch (eventName) {
  //     case "newShape":
  //       _self.store.shapes.push(eventData);
  //       break;
  //   }
  // };
  this.getHistoryStore = function () {
    return _self.store
  };
  this.rememberShapes = function() {
    _self.store.shapes = [];
    workspace.getShapes().forEach(function (shape) {
      if (!shape.attachedToShape && shape.type !== "appliances" && shape.getLines) {
        shape.lines = [];
        shape.getLines().forEach(function (line) {
          line.historyPointFeatures = line.getPointsFeatures();
          shape.lines.push(line);
        });
      }
      shape.historyPosition = shape.pos;
      _self.store.shapes.push(shape);
    });
    // console.log('saved', _self.store.shapes);
    _self.store.exportData = window.exportData;
  };
  this.rememberConfig = function(cfg) {
    _self.store.cfg = cfg;
  };
  this.restoreShapesFromHistory = function() {
    // console.log('_self.store.shapes', _self.store.shapes);
    workspace.removeAllShapes();
    _self.store.shapes.forEach(function (newShape) {
      if (newShape.lines) {
        workspace.addShape(newShape.lines, newShape.shapeType, newShape.historyPosition, newShape.partId, newShape.layoutName);
      } else {
        workspace.addImage(
          newShape.historyProps.image,
          newShape.historyProps.width,
          newShape.historyProps.depth,
          newShape.historyProps.attachedTo,
          newShape.historyProps.hoverShape,
          newShape.historyProps.type,
          newShape.historyProps.subType,
          newShape.historyProps.historyCallBack,
          newShape.historyPosition
        );
      }
    });
    _self.store.shapes.forEach(function (newShape) {  //  go again through all attached shapes and render lines text
      if (!newShape.lines) {
        newShape.historyProps.historyCallBack()
      }
    });
    // console.log('setted!', workspace.getShapes());
    Object.assign(_self.store.exportData, _self.store.cfg);
    setDataToQt(_self.store.exportData, true);
    setTimeout(function () {
      _self.store.exportData = window.exportData;
    }, 0);
  };
  // this.consoleShapesFromHistory = function() {
  //   console.log('_self.store.shapes', _self.store.shapes);
  // };
  this.checkForChangesApplied = function () { // this is called after cancel click
    // console.log('_self.store.exportData', _self.store.exportData);
    // console.log('window.exportData',window.exportData);
    let currentShapes = workspace.getShapes();

    //if (_self.store.exportData && (JSON.stringify(_self.store.exportData) !== JSON.stringify(window.exportData))) {
    //  return true; // check for exportData
    //}

    if (currentShapes.length !== _self.store.shapes.length) {
      return true; // check for appliances, etc.
    }

    let shapesChanged = false;

    workspace.getShapes().forEach(function (shape) {  // go through each shape && check for its changes
      //if (!shape.attachedToShape && shape.type !== "appliances") {
      if (shape instanceof sqftShape) {

        var historyShape = _self.store.shapes.find(function (historyShapetoFind) {
          return historyShapetoFind.id === shape.id
        });

        if (!historyShape) {
          shapesChanged = true
        }

        shape.getLines().forEach(function (line, index) {
          if (historyShape && historyShape.lines && historyShape.lines[index] && JSON.stringify(line.getPointsFeatures()) !== JSON.stringify(historyShape.lines[index].historyPointFeatures)) {
            shapesChanged = true
          }
        });
      }
    });

    return shapesChanged || false
  }
};
